export enum ResourceType {
  Icon,
  Download,
  Changelog,
  Description,
  Documentation
}
